import React from 'react';

const SvgDelete = props => (
  <svg width={15} height={19} {...props}>
    <path
      d="M1.5 4h12a.5.5 0 0 0 0-1h-12a.5.5 0 0 0 0 1zm-.5.915A1.5 1.5 0 0 1 1.5 2H4v-.5A1.5 1.5 0 0 1 5.5 0h4A1.5 1.5 0 0 1 11 1.5V2h2.5a1.5 1.5 0 0 1 .5 2.915v11.942C14 18.041 13.105 19 12 19H3c-1.105 0-2-.96-2-2.143V4.915zM13 5H2v11.917C2 17.515 2.448 18 3 18h9c.552 0 1-.485 1-1.083V5zm-3-3v-.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5V2h5zm-.5 1h-4 4zm-5 4a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0v-8a.5.5 0 0 1 .5-.5zm3 0a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0v-8a.5.5 0 0 1 .5-.5zm3 0a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0v-8a.5.5 0 0 1 .5-.5z"
      fill="#046FE2"
      fillRule="nonzero"
    />
  </svg>
);

export default SvgDelete;
